import React from 'react'
import { LabeledLineProps } from './LabeledLine.types'
import styles from './LabeledLine.module.scss'
import cl from 'classnames'
import { Text1 } from '../Text1'
import { useGetIsResponsiveScreen } from 'utilities'

const LabeledLineComponent = (props: LabeledLineProps) => {
  const {
    preset,
    label,
    labelIcon: LabelIcon,
    children,
    className,
    style = {},
    alignItems,
    innerContainerProps = {}
  } = props

  const { isResponsive: isMobile } = useGetIsResponsiveScreen('(max-width: 920px)')

  const isPresetTags = preset === 'tags'
  const isAlignFlexStart = isPresetTags || alignItems === 'flexStart'
  const isChildrenString = typeof children === 'string'

  const renderChildren = () => {
    return isChildrenString
      ? <Text1>{children}</Text1>
      : children
  }

  return (
    <div
      className={cl(styles.flexContainer, {
        [styles.flexStart]: isAlignFlexStart
      }, className)}
      style={{ alignItems, ...style }}
    >
      <Text1
        style={{
          width: 132,
          marginTop: isAlignFlexStart ? 5 : undefined,
          display: 'flex',
          alignItems: isAlignFlexStart ? 'flex-start' : 'center'
        }}
        className={isMobile && cl(styles.width)}
        overflowHidden={false}
        bold
      >
        {LabelIcon && (
          <LabelIcon
            style={{
              marginRight: 10.5,
              fill: styles.primary
            }}
          />
        )}
        {label}
      </Text1>

      <div
        className={cl(styles.childrenContainer, {
          [styles.tagsContainer]: isPresetTags
        }, innerContainerProps.className)}
        style={innerContainerProps.style}
      >
        {renderChildren()}
      </div>

    </div>
  )
}

const LabeledLine = LabeledLineComponent
export { LabeledLine }
